<div class="popup" >
    <div class="popup-content">
        <div class="eyeballs">
            <div class="eye left">
                <div class="pupil" #leftPupil></div>
            </div>
            <div class="eye right">
                <div class="pupil" #rightPupil></div>
            </div>
        </div>
        <h2>{{ data.message }}</h2>
        <div class="buttons">
            <button mat-button id="yesButton" (click)="onYesClick()">{{data.btn1text ? data.btn1text : 'Yes'}}</button>
            <button mat-button id="noButton" (click)="onNoClick()">{{data.btn2text ? data.btn2text : 'No'}}</button>
        </div>
    </div>
</div>
